import styled from '@emotion/styled'
import { FormEventHandler, ReactNode } from 'react'

import { DatePicker, DatePickerProps } from './DatePicker'
import { DigitInput, DigitInputProps } from './DigitInput'
import { Input, InputProps } from './Input'
import { Label, LabelProps } from './Label'
import { NumberInput, NumberInputProps } from './NumberInput'
import { Textarea, TextareaProps } from './Textarea'
import { BoxProps, box } from '../Box'

const FormElement = styled.form<BoxProps>((props) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  ...box(props),
}))

type FormProps = BoxProps & {
  action?: string | undefined
  autoComplete?: string | undefined
  children?: ReactNode
  method?: string | undefined
  name?: string | undefined
  noValidate?: boolean | undefined
  onSubmit?: FormEventHandler<HTMLFormElement> | undefined
  target?: string | undefined
}

const Form = (props: FormProps) => {
  return <FormElement {...props} />
}

Form.DatePicker = DatePicker
Form.Input = Input
Form.Label = Label
Form.NumberInput = NumberInput
Form.DigitInput = DigitInput
Form.Textarea = Textarea

export type {
  DatePickerProps as FormDatePickerProps,
  FormProps,
  InputProps as FormInputProps,
  LabelProps as FormLabelProps,
  NumberInputProps as FormNumberInputProps,
  DigitInputProps as FormDigitInputProps,
  TextareaProps as FormTextareaProps,
}
export { Form }
